import { render } from "./AreYourTyresLegal.vue?vue&type=template&id=1ad64eb5"
import script from "./AreYourTyresLegal.vue?vue&type=script&lang=js"
export * from "./AreYourTyresLegal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__